import { useActiveVenue } from './ActiveVenueProvider'

export const VenueTabs = () => {
  const {
    venues,
    activeVenueId,
    switchVenue,
    requestAddVenue,
    venuesUsed,
    venuesLimit,
    canManageVenues,
  } = useActiveVenue()
  const venuesAvailable = Math.max(0, venuesLimit - venuesUsed)

  if (venues.length === 0) {
    return null
  }

  return (
    <div className="market-venue-tabs" role="tablist" aria-label="Заведения">
      {venues.map((venue) => {
        const isActive = venue.id === activeVenueId
        return (
          <button
            key={venue.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={isActive ? 'market-venue-tabs__tab market-venue-tabs__tab--active' : 'market-venue-tabs__tab'}
            onClick={() => switchVenue(venue.id)}
          >
            {venue.name}
          </button>
        )
      })}
      {canManageVenues ? (
        <div className="market-venue-tabs__add-group">
          <button
            type="button"
            className="market-venue-tabs__add"
            aria-label="Добавить заведение"
            onClick={requestAddVenue}
          >
            + Добавить
          </button>
          <span className="echat-muted market-venue-tabs__limit" aria-live="polite">
            можно ещё {venuesAvailable}
            {venuesLimit > 0 ? ` (занято ${venuesUsed} из ${venuesLimit})` : ''}
          </span>
        </div>
      ) : null}
    </div>
  )
}
